import DateUtils from '../../../utils/dateUtils';
import { FormPickerDatas } from '../../../local-types';
import { Coords } from 'google-map-react';
import { CreateRankDTO } from '../api-types';

export interface RankFormData {
    name: string;
    'date-start': string;
    'date-end'?: string;
    polygon: Array<Coords>;
    dispatch_group: any[];
    no_time_limit?: boolean;
}

export const mapFormToRankDTO = (formData: RankFormData): CreateRankDTO => {
    return {
        name: formData.name,
        area: {
            polygon: formData.polygon,
        },
        dispatch_groups: formData.dispatch_group.map((dg: FormPickerDatas) => ({
            dispatch_group_id: dg.id,
        })),
        start_datetime: DateUtils.dateToSQlDateTime(new Date(Number(formData['date-start']) * 1000)),
        end_datetime: formData['date-end']
            ? DateUtils.dateToSQlDateTime(new Date(Number(formData['date-end']) * 1000))
            : null,
    };
};
